(function (){
    'use strict';

    angular
        .module('app')
        .run(Startup);

    Startup.$inject = ['$rootScope', 'AuthService', '$state', 'UserService', 'AclService', '$urlRouter', '$location'];

    function Startup($rootScope, AuthService, $state, UserService, AclService, $urlRouter, $location){

        alertify.set('notifier','position', 'top-left');

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
            var stateName = toState.name;
            if (stateName.startsWith('auth.') && stateName !=='auth.logout' && stateName !=='auth.partners.logout' && stateName !=='auth.platformRental.logout') {

                
                if (AuthService.isLoggedIn()) {

                    AuthService.getRole().then(function (role){
                        AclService.attachRole(role);
                        if(AuthService.isAdmin()) {
                            $state.go('root.dashboard');
                        } else if(AuthService.isPartner()) {
                            $state.go('root.partner.dashboard');
                        } else if(AuthService.isPlatformRental()) {
                            $state.go('platformRental.dashboard');
                        } else {
                            $state.go('auth.logout');
                        }
                    });
                }
            } else {
                if (stateName.startsWith('root') && !stateName.startsWith('root.partner') && !stateName.startsWith('root.platformRental') && !AuthService.isAdmin()) {
                    event.preventDefault();
                    $state.go('auth.logout');
                    // $location.url('auth.logout');
                } else if (
                    stateName.startsWith('root.partner') 
                    && !stateName.startsWith('root.partners.list') 
                    && !stateName.startsWith('root.partners.create') 
                    && !stateName.startsWith('root.partners.edit')
                    && !stateName.startsWith('root.partners.report-career-advisors')
                    && !stateName.startsWith('root.partners.report-tsw')
                    && !stateName.startsWith('root.partners.report-students')
                    && !stateName.startsWith('root.partners.clients')
                    && !stateName.startsWith('root.partners.users')
                    && !stateName.startsWith('root.partners.users.form') 
                    && !AuthService.isPartner()){
                    event.preventDefault();
                    $state.go('auth.partners.logout');
                } else if (stateName.startsWith('root.platformRental') && !AuthService.isPlatformRental()){
                    event.preventDefault();
                    $state.go('auth.platformRental.logout');
                }

                // if (stateName.startsWith('root') && !AuthService.isLoggedIn()) {
                //     $state.go('auth.login', {});
                // }
            }
        });

        $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error){
            if(toState.name === 'auth.activate') {
                $state.go('auth.fail');
            }
        });

        // $rootScope.can = function(permission) {
        //     permission = permission.toLowerCase();
        
        //     if(!AuthService.currentUser)
        //         return false;
        
        //     var roles = AuthService.currentUser.roles.map(function(role){
        //         return role.name.toLowerCase();
        //     });
        
        //     if(roles.indexOf('admin') !== -1)
        //         return true;
        //     return AclService.can(permission);
        // };

        // $rootScope.hasRole = function (role) {
        //     role = role.toLowerCase();
        //
        //     if(!AuthService.currentUser)
        //         return false;
        //
        //     var roles = AuthService.currentUser.roles.map(function(role){
        //         return role.name.toLowerCase();
        //     });
        //
        //     console.log(roles);
        //     if(roles.indexOf('admin') !== -1){
        //         return true;
        //     } else {
        //         if(roles.indexOf(role) !== -1)
        //             return true;
        //
        //     }
        //     return false;
        // }
    }

})();